import { COMPANY } from 'constants/general';
import fetch from 'features/common/fetch';

import { actions } from './reducer';
import { getSellers, getSellersForSidebar } from './selectors';

export const fetchSellers = ({
	formName,
	channelId,
	regionId,
	agencyId,
	managerLogin,
	type,
	onSuccess,
	customAllowedSellers,
}) => {
	return async (dispatch, getState, { getFormData }) => {
		const formData = await getFormData(formName);

		return dispatch(
			fetch.actions.get(fetch.constants.urls.orgStructureSellers, {
				uniqueReqID: type ? type : null,
				queryParams: {
					companyId: COMPANY.CP,
					channelId,
					regionId,
					agencyId,
					managerLogin,
				},
				onSuccess: [
					(response) => () => {
						dispatch(actions.appendData(response.body));

						const finalSellers =
							type === 'sidebar'
								? getSellersForSidebar(getState(), formData, customAllowedSellers)
								: getSellers(getState(), formData);

						onSuccess(finalSellers);
					},
				],
			}),
		);
	};
};
